// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const lands = {
  id: "lands",
  title: "Lands",
  type: "group",
  children: [
    {
      id: "lands",
      title: "Lands",
      type: "item",
      url: "/lands",
    },
  ],
};

export default lands;
